import React from "react";

import TallargeLogoFull from "../../assets/Tallarge_final.png";
import TallargeLogoIcon from "../../assets/Tallarge_LOGO.png";

import IconOverview from "../../assets/tallarge_icon_overview.ico";
import IconJobs from "../../assets/tallarge_icon_jobs.ico";
import IconMembers from "../../assets/tallarge_icon_members.ico";
import IconChat from "../../assets/tallarge_icon_chat.ico";
import IconData from "../../assets/tallarge_icon_data.ico";
import IconPackages from "../../assets/tallarge_icon_packages.ico";
import IconVehicles from "../../assets/tallarge_icon_vehicles.ico";
import IconReports from "../../assets/tallarge_icon_reports.ico";
import IconCompany from "../../assets/tallarge_icon_company.ico";
import IconSettings from "../../assets/tallarge_icon_settings.ico";

// 保留原本的 icon 名稱對應，其他地方若有使用也能相容。
export const DRIVER_MANAGER_ICON_ASSETS = {
  grid: IconOverview,
  overview: IconOverview,

  briefcase: IconJobs,
  jobs: IconJobs,

  users: IconMembers,
  members: IconMembers,

  chat: IconChat,

  folder: IconData,
  data: IconData,
  book: IconData,
  cargo: IconPackages,
  packages: IconPackages,

  truck: IconVehicles,
  vehicles: IconVehicles,

  bar: IconReports,
  reports: IconReports,

  company: IconCompany,
  building: IconCompany,

  gear: IconSettings,
  settings: IconSettings,
};

const SHOW_LOCAL_DELIVERY_DETAILS =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname);

export const DRIVER_MANAGER_MENU_ITEMS = [
  { key: "overview", label: "總覽", icon: "grid" },
  { key: "internalJob", label: "工作管理", icon: "briefcase" },
  { key: "cargoManagement", label: "貨物管理", icon: "packages" },
  ...(SHOW_LOCAL_DELIVERY_DETAILS
    ? [{ key: "deliveryDetails", label: "配送(測試)", icon: "packages" }]
    : []),
  { key: "drivers", label: "成員管理", icon: "users" },
  { key: "chats", label: "聊天室", icon: "chat" },
  { key: "commonInfo", label: "常用資訊", icon: "book" },
  { key: "fleet", label: "資產管理", icon: "truck" },
  { key: "reports", label: "報表中心", icon: "bar" },
  { key: "settings", label: "系統設定", icon: "gear" },
];

const SIDEBAR_MENU_LABEL_FONT_SIZE = 16;
const SIDEBAR_SCROLLBAR_WIDTH = 8;
const SIDEBAR_WIDTH_FIXED_CHROME =
  18 * 2 + 18 * 2 + 40 + 14 + 3 + SIDEBAR_SCROLLBAR_WIDTH;
const SIDEBAR_WIDTH_SAFETY_SPACE = 0;
const longestMenuLabelCharacterCount = Math.max(
  0,
  ...DRIVER_MANAGER_MENU_ITEMS.map((item) => Array.from(String(item.label || "")).length),
);

// 依最長中文 label 的字數計算展開欄寬：固定寬包含側欄留白、按鈕留白、圖示/gap、選單右側留白；另留 scrollbar 與字型差異空間。
export const DRIVER_MANAGER_SIDEBAR_EXPANDED_WIDTH = Math.ceil(
  SIDEBAR_WIDTH_FIXED_CHROME +
    longestMenuLabelCharacterCount * SIDEBAR_MENU_LABEL_FONT_SIZE +
    SIDEBAR_WIDTH_SAFETY_SPACE,
);
const SIDEBAR_SCROLLBAR_CSS = `
.dmh-sidebar-scroll { scrollbar-width: thin; scrollbar-color: transparent transparent; }
.dmh-sidebar-scroll::-webkit-scrollbar { width: ${SIDEBAR_SCROLLBAR_WIDTH}px; height: ${SIDEBAR_SCROLLBAR_WIDTH}px; }
.dmh-sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
.dmh-sidebar-scroll::-webkit-scrollbar-thumb { background: transparent; border-radius: 999px; }
.dmh-sidebar-scroll::-webkit-scrollbar-button { display: none; width: 0; height: 0; }
.dmh-sidebar-hover-scroll:hover .dmh-sidebar-scroll { scrollbar-color: #D7DDE2 transparent; }
@media (min-width: 561px) and (max-width: 1279px) {
  .dmh-sidebar-scroll { padding-bottom: 72px !important; }
}
.dmh-sidebar-hover-scroll:hover .dmh-sidebar-scroll::-webkit-scrollbar-thumb { background: #D7DDE2; }
`;

const DRIVER_MANAGER_WORK_VIEWS = new Set([
  "jobDetail",
  "logisticsJobDetail",
  "createInternal",
  "createLogistics",
  "quickLogistics",
  "quickLogisticsVehicle",
  "quickLogisticsClustering",
]);

const COLORS = {
  white: "#FFFFFF",
  text: "#20242B",
  textSoft: "#6E737B",
  line: "rgba(15,23,42,0.09)",
  orange: "#F88927",
  orangeDeep: "#C45A10",
  orangeSoft: "#FFF1E5",
  hover: "#F7F8FA",
};

// ICO 含多種尺寸，側欄以 34×34 顯示於 40×40 圖示容器。
// 圖片包含透明留白，因此圖示主體會略小於 34px。
const MENU_ICON_SIZE = 34;

const styles = {
  sidebar: {
    position: "relative",
    zIndex: 20,
    minWidth: 0,
    minHeight: 0,
    background: COLORS.white,
    borderRight: "none",
    padding: "18px 18px 0",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    transition: "padding 280ms ease",
    boxSizing: "border-box",
  },

  sidebarCollapsed: {
    padding: "18px 12px 0",
  },

  logoStage: {
    position: "relative",
    width: "100%",
    height: 64,
    flexShrink: 0,
    overflow: "hidden",
    marginBottom: 4,
  },

  logoFull: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: 150,
    height: "auto",
    objectFit: "contain",
    display: "block",
    pointerEvents: "none",
    willChange: "transform, opacity",
    transition: "opacity 220ms ease, transform 320ms cubic-bezier(0.22, 0.72, 0.24, 1)",
  },

  logoIcon: {
    position: "absolute",
    top: "50%",
    left: "50%",
    width: 50,
    height: 50,
    objectFit: "contain",
    display: "block",
    pointerEvents: "none",
    willChange: "transform, opacity",
    transition: "opacity 220ms ease, transform 320ms cubic-bezier(0.22, 0.72, 0.24, 1)",
  },

  toggleRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minHeight: 40,
    flexShrink: 0,
    marginBottom: 4,
  },

  toggleButton: {
    width: 38,
    height: 38,
    display: "grid",
    placeItems: "center",
    border: 0,
    borderRadius: 12,
    background: "transparent",
    color: COLORS.text,
    cursor: "pointer",
    transition: "color 160ms ease",
  },

  menuList: {
    flex: "1 1 auto",
    display: "grid",
    alignContent: "start",
    gap: 10,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    padding: "0 3px 0 0",
    overscrollBehavior: "contain",
  },

  menuButton: {
    position: "relative",
    width: "100%",
    minHeight: 58,
    display: "flex",
    alignItems: "center",
    gap: 14,
    padding: "0 18px",
    border: "none",
    borderRadius: 18,
    background: "transparent",
    color: COLORS.text,
    fontFamily: "inherit",
    fontSize: SIDEBAR_MENU_LABEL_FONT_SIZE,
    fontWeight: 800,
    letterSpacing: "-0.01em",
    textAlign: "left",
    cursor: "pointer",
    boxSizing: "border-box",
    transition:
      "background-color 160ms ease, color 160ms ease, border-color 160ms ease",
  },

  menuButtonHover: {
    background: COLORS.hover,
  },

  menuButtonCollapsed: {
    justifyContent: "center",
    padding: "7px 0",
    gap: 0,
  },

  menuButtonActive: {
    background: "linear-gradient(135deg, #FF9736 0%, #F67E1F 100%)",
    color: COLORS.white,
    boxShadow: "0 10px 24px rgba(246,139,44,0.28)",
  },

  menuLabel: {
    minWidth: 0,
    flex: 1,
    lineHeight: 1.4,
    whiteSpace: "nowrap",
  },

  menuIconWrap: {
    width: 40,
    height: 40,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 40px",
    pointerEvents: "none",
  },

  imageIcon: {
    display: "block",
    objectFit: "contain",
    flexShrink: 0,
    userSelect: "none",
    pointerEvents: "none",
  },

  mobileOverlay: {
    position: "fixed",
    inset: 0,
    zIndex: 49,
    background: "rgba(15,23,42,0.35)",
  },

  mobileSidebar: {
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 50,
    width: "min(86vw, 290px)",
    padding: "20px 20px 0",
    background: COLORS.white,
    boxShadow: "18px 0 44px rgba(15,23,42,0.16)",
    overflowY: "auto",
    boxSizing: "border-box",
  },

  mobileTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    minHeight: 64,
    marginBottom: 17,
  },

  mobileLogo: {
    width: 168,
    maxWidth: "calc(100% - 48px)",
    height: "auto",
    objectFit: "contain",
  },

  closeButton: {
    width: 36,
    height: 36,
    flexShrink: 0,
    border: `1px solid ${COLORS.line}`,
    borderRadius: 12,
    background: COLORS.white,
    color: COLORS.text,
    fontSize: 18,
    lineHeight: 1,
    cursor: "pointer",
  },

  topbar: {
    position: "relative",
    zIndex: 10,
    height: 78,
    flex: "0 0 78px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 20,
    padding: "0 26px",
    background: "rgba(255,255,255,0.94)",
    borderBottom: `1px solid ${COLORS.line}`,
    backdropFilter: "blur(16px)",
  },

  topbarLeft: {
    minWidth: 0,
    display: "flex",
    alignItems: "center",
    gap: 12,
  },

  mobileMenuButton: {
    width: 40,
    height: 40,
    display: "grid",
    placeItems: "center",
    border: `1px solid ${COLORS.line}`,
    borderRadius: 12,
    background: COLORS.white,
    color: COLORS.text,
    cursor: "pointer",
  },

  topbarRight: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    flex: "0 0 auto",
  },

  accountMenu: {
    position: "absolute",
    top: "calc(100% + 10px)",
    right: 0,
    minWidth: 190,
    padding: 8,
    border: `1px solid ${COLORS.line}`,
    borderRadius: 14,
    background: COLORS.white,
    boxShadow: "0 14px 34px rgba(15,23,42,0.14)",
    zIndex: 30,
  },

  accountMenuLabel: {
    padding: "8px 10px 9px",
    color: COLORS.text,
    fontSize: 13,
    fontWeight: 550,
    borderBottom: `1px solid ${COLORS.line}`,
  },

  accountMenuButton: {
    width: "100%",
    minHeight: 36,
    border: 0,
    borderRadius: 9,
    background: "transparent",
    color: COLORS.text,
    fontFamily: "inherit",
    fontSize: 13,
    fontWeight: 650,
    textAlign: "left",
    padding: "0 10px",
    cursor: "pointer",
  },

  iconButton: {
    position: "relative",
    width: 40,
    height: 40,
    display: "grid",
    placeItems: "center",
    border: 0,
    borderRadius: 12,
    background: "transparent",
    color: COLORS.textSoft,
    cursor: "pointer",
    transition: "background-color 160ms ease, color 160ms ease",
  },

  avatarButton: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: 0,
    border: 0,
    background: "transparent",
    color: COLORS.textSoft,
    cursor: "pointer",
  },

  avatar: {
    width: 40,
    height: 40,
    display: "grid",
    placeItems: "center",
    overflow: "hidden",
    borderRadius: "50%",
    background: "linear-gradient(135deg,#CBD5E1,#94A3B8)",
    color: COLORS.white,
    fontSize: 16,
    fontWeight: 850,
  },

  avatarImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  notificationDot: {
    position: "absolute",
    top: 7,
    right: 7,
    width: 8,
    height: 8,
    border: `2px solid ${COLORS.white}`,
    borderRadius: "50%",
    background: "#F04444",
  },

  icon: {
    width: 22,
    height: 22,
    display: "block",
  },

  smallIcon: {
    width: 17,
    height: 17,
    display: "block",
  },
};

// 共用 ICO 圖示元件。
// 不套用 CSS filter，保留原始橘白配色與立體陰影。
export function SidebarIcon({
  type,
  size = MENU_ICON_SIZE,
  style,
}) {
  const src =
    DRIVER_MANAGER_ICON_ASSETS[type] ||
    DRIVER_MANAGER_ICON_ASSETS.overview;

  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      draggable={false}
      width={size}
      height={size}
      style={{
        ...styles.imageIcon,
        width: size,
        height: size,
        ...style,
      }}
    />
  );
}

function SidebarMenuButton({
  item,
  active,
  collapsed,
  onSelect,
}) {
  const [hovered, setHovered] = React.useState(false);

  return (
    <button
      type="button"
      title={collapsed ? item.label : undefined}
      aria-label={item.label}
      aria-current={active ? "page" : undefined}
      onClick={() => onSelect?.(item.key)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...styles.menuButton,
        ...(hovered && !active ? styles.menuButtonHover : {}),
        ...(active ? styles.menuButtonActive : {}),
        ...(collapsed ? styles.menuButtonCollapsed : {}),
      }}
    >
      <span style={styles.menuIconWrap}>
        <SidebarIcon type={item.icon} />
      </span>

      {!collapsed && (
        <span style={styles.menuLabel}>{item.label}</span>
      )}
    </button>
  );
}

export function DriverManagerSidebar({
  activeKey,
  collapsed = false,
  mobile = false,
  onSelect,
  onToggle,
  onClose,
}) {
  const activeMenu = DRIVER_MANAGER_WORK_VIEWS.has(activeKey)
    ? "internalJob"
    : activeKey === "chatRoom"
      ? "chats"
      : activeKey;

  const iconOnly = collapsed && !mobile;
  const sidebarHorizontalInset = collapsed ? 12 : 18;
  const menuListStyle = {
    ...styles.menuList,
    ...(mobile ? {} : {
      marginRight: -sidebarHorizontalInset,
      paddingRight: 3 + sidebarHorizontalInset,
    }),
  };

  const menu = (
    <>
      <style>{SIDEBAR_SCROLLBAR_CSS}</style>
      <nav className="dmh-sidebar-scroll" style={menuListStyle} aria-label="車隊管理主選單">
        {DRIVER_MANAGER_MENU_ITEMS.map((item) => (
          <SidebarMenuButton
            key={item.key}
            item={item}
            active={activeMenu === item.key}
            collapsed={iconOnly}
            onSelect={onSelect}
          />
        ))}
      </nav>
    </>
  );

  if (mobile) {
    return (
      <>
        <div style={styles.mobileOverlay} onClick={onClose} />

        <aside
          className="dmh-sidebar-hover-scroll"
          style={styles.mobileSidebar}
          aria-label="車隊管理選單"
        >
          <div style={styles.mobileTop}>
            <img
              src={TallargeLogoFull}
              alt="Tallarge"
              style={styles.mobileLogo}
              draggable={false}
            />

            <button
                type="button"
                aria-label="關閉選單"
                style={styles.closeButton}
                onClick={onClose}
            >
              ×
            </button>
          </div>

          {menu}
        </aside>
      </>
    );
  }

  return (
    <aside
      className="dmh-sidebar-hover-scroll"
      style={{
        ...styles.sidebar,
        ...(collapsed ? styles.sidebarCollapsed : {}),
      }}
      aria-label="車隊管理側邊欄"
    >
      <div style={styles.logoStage}>
        <img
          src={TallargeLogoFull}
          alt={collapsed ? "" : "Tallarge"}
          aria-hidden={collapsed}
          style={{
            ...styles.logoFull,
            opacity: collapsed ? 0 : 1,
            transform: collapsed
              ? "translate(calc(-50% + 32px), -50%)"
              : "translate(-50%, -50%)",
          }}
          draggable={false}
        />
        <img
          src={TallargeLogoIcon}
          alt={collapsed ? "Tallarge" : ""}
          aria-hidden={!collapsed}
          style={{
            ...styles.logoIcon,
            opacity: collapsed ? 1 : 0,
            transform: collapsed
              ? "translate(-50%, -50%)"
              : "translate(calc(-50% - 32px), -50%)",
          }}
          draggable={false}
        />
      </div>

      <div
        style={{
          ...styles.toggleRow,
          justifyContent: collapsed ? "center" : "flex-end",
        }}
      >
        <button
          type="button"
          style={styles.toggleButton}
          title={collapsed ? "展開側邊欄" : "收合側邊欄"}
          aria-label={collapsed ? "展開側邊欄" : "收合側邊欄"}
          aria-expanded={!collapsed}
          onClick={onToggle}
        >
          {collapsed ? <PanelLeftOpenIcon /> : <PanelLeftCloseIcon />}
        </button>
      </div>

      {menu}
    </aside>
  );
}

export function DriverManagerTopbar({
  isMobile = false,
  onMenuPress,
  onNotificationPress,
  onAccountAction,
  hasUnreadNotifications = false,
  user,
  account,
}) {
  const [accountMenuOpen, setAccountMenuOpen] = React.useState(false);

  const displayName =
    String(account?.displayName || user?.displayName || "管理員").trim() ||
    "管理員";

  const avatarUrl = String(
    account?.photoURL || user?.photoURL || ""
  ).trim();

  const initial = displayName.slice(0, 1) || "管";

  const handleAccountAction = (action) => {
    setAccountMenuOpen(false);
    onAccountAction?.(action);
  };

  return (
    <header style={styles.topbar}>
      <div style={styles.topbarLeft}>
        {isMobile && (
          <button
            type="button"
            style={styles.mobileMenuButton}
            aria-label="開啟側邊欄"
            onClick={onMenuPress}
          >
            <PanelIcon />
          </button>
        )}
      </div>

      <div style={{ ...styles.topbarRight, position: "relative" }}>
        <button
          type="button"
          style={styles.iconButton}
          aria-label="通知"
          onClick={onNotificationPress}
        >
          <BellIcon />

          {hasUnreadNotifications && (
            <span style={styles.notificationDot} />
          )}
        </button>

        <button
          type="button"
          style={styles.avatarButton}
          aria-label={`${displayName}帳號選單`}
          aria-expanded={accountMenuOpen}
          onClick={() => setAccountMenuOpen((open) => !open)}
        >
          <span style={styles.avatar}>
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt=""
                style={styles.avatarImage}
              />
            ) : (
              initial
            )}
          </span>

          <ChevronDownIcon />
        </button>

        {accountMenuOpen && (
          <div style={styles.accountMenu} role="menu">
            <div style={styles.accountMenuLabel}>
              {displayName}
            </div>

            <button
              type="button"
              role="menuitem"
              style={styles.accountMenuButton}
              onClick={() => handleAccountAction("profile")}
            >
              個人資料
            </button>

            <button
              type="button"
              role="menuitem"
              style={styles.accountMenuButton}
              onClick={() => handleAccountAction("settings")}
            >
              系統設定
            </button>

            <button
              type="button"
              role="menuitem"
              style={styles.accountMenuButton}
              onClick={() => handleAccountAction("logout")}
            >
              登出
            </button>
          </div>
        )}
      </div>
    </header>
  );
}

// 保留既有具名 export，避免其他頁面 import 時出錯。
export function BriefcaseIcon({ size = 22, style } = {}) {
  return (
    <SidebarIcon
      type="briefcase"
      size={size}
      style={style}
    />
  );
}

export function TruckIcon({ size = 22, style } = {}) {
  return (
    <SidebarIcon
      type="truck"
      size={size}
      style={style}
    />
  );
}

// 收合、通知、箭頭等操作圖示維持 SVG，
// 這些不屬於本次十張選單 ICO。
function LineIcon({ children, small = false }) {
  return (
    <svg
      viewBox="0 0 24 24"
      style={small ? styles.smallIcon : styles.icon}
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </svg>
  );
}

function PanelIcon() {
  return (
    <LineIcon>
      <path d="M4 7h16M4 12h16M4 17h16" />
    </LineIcon>
  );
}

function BellIcon() {
  return (
    <LineIcon>
      <path d="M6.5 9.5a5.5 5.5 0 1 1 11 0v3.1c0 .7.2 1.3.6 1.8l.9 1.3H5l.9-1.3c.4-.5.6-1.1.6-1.8V9.5Zm3.7 9.2a2.5 2.5 0 0 0 3.6 0" />
    </LineIcon>
  );
}

function ChevronDownIcon() {
  return (
    <LineIcon small>
      <path d="m7 10 5 5 5-5" />
    </LineIcon>
  );
}

function PanelLeftCloseIcon() {
  return (
    <LineIcon>
      <path d="m15 6-6 6 6 6" />
    </LineIcon>
  );
}

function PanelLeftOpenIcon() {
  return (
    <LineIcon>
      <path d="m9 6 6 6-6 6" />
    </LineIcon>
  );
}
